module.exports = __webpack_public_path__ + "img/btn-arrow-pro.db3ed5e1.svg";